// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { CargoMartPlansType } from '@cai-services';
import { SessionService } from '../../../_services/session.service';
import { MenuConfigService } from './menu-config.service';

@Injectable()
export class MenuHorizontalService {
  // Public properties
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  /**
   *
   * @param menuConfigService
   * @param sessionService
   */

  private extraMenuItems = [
    {
      title: $localize`:@@global.personal-settings:Personal Settings`,
      root: true,
      alignment: 'left',
      page: 'forwarder/profile/personal-settings',
    },
    {
      title: $localize`:@@global.company-settings:Company Settings`,
      root: true,
      alignment: 'left',
      page: 'settings/office-settings',
    },
    {
      title: $localize`:@@global.sign-out:Sign Out`,
      root: true,
      alignment: 'left',
      page: null,
    },
  ];

  constructor(
    private menuConfigService: MenuConfigService,
    private readonly sessionService: SessionService,
  ) {
    this.loadMenu();
    this.sessionService.watchSessionStorage().subscribe((res) => {
      if (res.key === 'currentUser') {
        this.loadMenu();
      }
    });
  }
  /**
   * Load menu list
   */

  loadMenu() {
    const menuItems: any[] = objectPath.get(
      this.menuConfigService.getMenus(),
      'header.items',
    );
    if (window.innerWidth < 1025) {
      const hasExtraMenuItems = this.extraMenuItems?.every((extraItem) =>
        menuItems?.some((item) => item.page === extraItem.page),
      );

      if (!hasExtraMenuItems && menuItems) {
        this.menuList$.next([...menuItems, ...this.extraMenuItems]);
      }
    } else {
      this.menuList$.next(menuItems);
    }
  }

  async shouldShowUpgradeButton(currentUser) {
    const currentOffice = this.sessionService.getSelectedOffice(),
      updatedOffice = currentUser?.officeAccesses?.find(
        (officeAccess) => currentOffice?.id === officeAccess?.office?.id,
      );

    return updatedOffice?.office?.plan === CargoMartPlansType.FREE;
  }

  shouldDisplayProLogo(CurrentUser) {
    const selectedOfficeId = this.sessionService.getSelectedOfficeId(),
      officeAccess = CurrentUser?.officeAccesses?.find(
        (oa) => oa.office.id == selectedOfficeId,
      ),
      office = officeAccess ? officeAccess.office : null;
    return (
      office?.plan === CargoMartPlansType.PRO ||
      office?.plan === CargoMartPlansType.TRIAL ||
      office?.plan === CargoMartPlansType.MONTHLY_TRIAL
    );
  }
}
